import { useLocation, useHistory } from 'react-router-dom';

const useFeedbackFilters = (initialPageSize = 10) => {
  const history = useHistory();
  const location = useLocation();

  const parseParams = () => {
    const params = new URLSearchParams(location.search);
    return {
      year: params.get('year') || '',
      state: params.get('state') || '',
      documentType: params.get('documentType') || '',
      subject: params.get('subject') || '',
      taskType: params.get('taskType') || params.get('documentType') || '',
      responseType: params.get('responseType') || '',
      sortDirection: params.get('sortDirection') ? params.get('sortDirection') === 'DESC' : true,
      page: (parseInt(params.get('page')) || 1) - 1,
    };
  };

  const filters = parseParams();

  const updateURL = (newParams) => {
    const params = new URLSearchParams(location.search);

    Object.entries(newParams).forEach(([key, value]) => {
      if (key === 'page') {
        const pageValue = (value || 0) + 1;
        params.set(key, pageValue.toString());
      } else if (value || value === 0) {
        params.set(key, value.toString());
      } else {
        params.delete(key);
      }
    });

    if (!('page' in newParams)) {
      params.set('page', '1');
    }

    history.push(`${location.pathname}?${params}`);
  };

  const handleFilterChange = (key, value) => {
    updateURL({ [key]: value });
  };

  const handleSortChange = (desc) => {
    updateURL({ sortDirection: desc ? 'DESC' : 'ASC' });
  };

  const handlePageChange = (newPage) => {
    updateURL({ page: newPage });
  };

  const resetFilters = () => {
    const params = new URLSearchParams();
    params.set('page', '1');
    history.push(`${location.pathname}?${params}`);
  };

  const getTaskSubjectCodesAndTitles = (t) => {
    const code =
      t?.assignment?.subjectCode ||
      (t?.assignment?.subjects?.[0] && typeof t.assignment.subjects[0] === 'object'
        ? t.assignment.subjects[0].subjectCode || t.assignment.subjects[0].code
        : t?.assignment?.subjects?.[0]) ||
      t?.subjectCode ||
      t?.subject ||
      '';
    const title =
      (t?.assignment?.subjects?.[0] && typeof t.assignment.subjects[0] === 'object' && (t.assignment.subjects[0].subjectName || t.assignment.subjects[0].title)) ||
      t?.assignment?.subjectName ||
      t?.subjectName ||
      '';
    return [String(code).toLowerCase().trim(), String(title).toLowerCase().trim()].filter(Boolean);
  };

  const applyFrontendFiltering = (tasks) => {
    const subjectLower = String(filters.subject || '').toLowerCase().trim();
    const filtered = (tasks || []).filter(
      (t) =>
        (!filters.year || t.year === filters.year || t?.assignment?.year === filters.year) &&
        (!filters.state || t.state === filters.state) &&
        (!filters.documentType || t.documentType === filters.documentType || t?.assignment?.type === filters.documentType || t?.assignment?.taskType === filters.documentType) &&
        (!subjectLower || getTaskSubjectCodesAndTitles(t).some((s) => s === subjectLower)) &&
        (!filters.taskType || (t?.assignment?.taskType || t?.assignment?.type) === filters.taskType) &&
        (!filters.responseType || (t?.assignment?.responseType || t?.responseType) === filters.responseType)
    );
    return filtered.sort((a, b) => {
      const aTime = new Date(a.requestedAt || a.reviewedAt || 0).getTime();
      const bTime = new Date(b.requestedAt || b.reviewedAt || 0).getTime();
      return filters.sortDirection ? bTime - aTime : aTime - bTime;
    });
  };

  return {
    selectedYear: filters.year,
    selectedState: filters.state,
    selectedDocumentType: filters.documentType,
    selectedSubject: filters.subject,
    selectedTaskType: filters.taskType,
    selectedResponseType: filters.responseType,
    sortItem: filters.sortDirection,
    currentPage: filters.page,
    pageSize: initialPageSize,
    filterConfig: {
      page: filters.page,
      size: initialPageSize,
      state: filters.state,
      year: filters.year,
      subject: filters.subject,
      documentType: filters.documentType,
      taskType: filters.taskType,
      responseType: filters.responseType,
      sortDirection: filters.sortDirection ? 'DESC' : 'ASC',
      sortBy: 'reviewedAt',
    },
    handleFilterChange,
    setSortItem: handleSortChange,
    handlePageChange,
    resetFilters,
    applyFrontendFiltering,
  };
};

export default useFeedbackFilters;